// extracted by mini-css-extract-plugin
export var box = "news-post-box-module--box--vSBt3";
export var button = "news-post-box-module--button--dbmJw";
export var container = "news-post-box-module--container--+YJ1w";
export var header = "news-post-box-module--header--7k2+h";
export var headerImage = "news-post-box-module--header-image--kqFsH";
export var title = "news-post-box-module--title--Qijk3";